/**
 * Net payable for payment list columns (after VAT/CIS; reverse charge when approved).
 */

export function getPaymentNetPayable(payment) {
  if (!payment) return null;
  const raw = payment.total_payable ?? payment.total_amount ?? null;
  if (raw === null || raw === undefined || raw === '') return null;
  const n = parseFloat(raw);
  return Number.isFinite(n) ? n : null;
}

export function formatPaymentNetPayable(payment, { prefix = '£', fallback = '0.00' } = {}) {
  const n = getPaymentNetPayable(payment);
  const formatted = n != null ? n.toFixed(2) : fallback;
  return prefix ? `${prefix}${formatted}` : formatted;
}
